import React, { useCallback, useEffect } from "react";
import { Button, Form, Input, Row } from 'antd';
import MapFormItem from "./MapFormItem";

const itemLayout = {
  // labelCol: { span: 6 },
  // wrapperCol: { span: 18 },
}

function AddressForm({ form, value, onChange }) {
  const { getFieldDecorator } = form;

  const onSubmit = useCallback((e) => {
    e.stopPropagation();

    form.validateFields((err, values) => {
      if (err) {
        console.log('Received values of form: ', err);
        return;
      }

      values.id = value.id;
      values.full = getFullAddress(values);
      onChange(values);
    });
  }, [form, value]);

  useEffect(() => {
    if (value) {
      form.setFields({
        line1: {
          value: value.line1
        }, line2: {
          value: value.line2
        }, city: {
          value: value.city
        }, state: {
          value: value.state
        }, country: {
          value: value.country
        }, zip: {
          value: value.zip
        }, coordinate: {
          value: value.coordinate
        }
      })
    }
  }, [])

  return (
    <Form layout="vertical" className="address-form">
      <Row type="flex" justify="end">
        <Button type="primary" onClick={onSubmit}>Update</Button>
      </Row>
      <Form.Item label="Line 1" {...itemLayout}>
        {getFieldDecorator('line1', {
          rules: [{
            required: true,
            message: 'Please input line 1',
          }],
        })(<Input/>)}
      </Form.Item>
      <Form.Item label="Line 2" {...itemLayout}>
        {getFieldDecorator('line2')(<Input/>)}
      </Form.Item>
      <Form.Item label="City" {...itemLayout}>
        {getFieldDecorator('city', {
          rules: [{ required: true, }],
        })(<Input/>)}
      </Form.Item>
      <Form.Item label="State" {...itemLayout}>
        {getFieldDecorator('state', {
          rules: [{ required: true, }],
        })(<Input/>)}
      </Form.Item>
      <Form.Item label="Postal Code" {...itemLayout}>
        {getFieldDecorator('zip', {
          rules: [{ required: true, }],
        })(<Input/>)}
      </Form.Item>
      <Form.Item label="Country" {...itemLayout}>
        {getFieldDecorator('country', {
          rules: [{ required: true, }],
        })(<Input/>)}
      </Form.Item>
      <Form.Item label="Coordinate" {...itemLayout}>
        {getFieldDecorator('coordinate', {
          rules: [{ required: true, }],
        })(<MapFormItem/>)}
      </Form.Item>
    </Form>
  );
}

export default Form.create({ name: 'address-form' })(AddressForm);


function getFullAddress(address) {
  const {main, secondary} = getFormattedAddress(address);
  return `${main}, ${secondary}`;
}

function getFormattedAddress({ line1, line2, zip, city, state, county, country }) {
  let main = add(line1, false);
  main += add(line2);

  let secondary = add(zip, false);
  secondary += add(city);
  secondary += add(state || county);
  secondary += add(country);

  return {
    main,
    secondary,
  };

  function add(data, commaBefore = true) {
    return data ? `${commaBefore ? ', ' : ''}${data}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/Form.js